import React, { createContext, useContext, useState } from 'react';

// Create the context
export const RoleContext = createContext();

// Provider component
export const RoleProvider = ({ children }) => {
  const [selectedRole, setSelectedRole] = useState('client');

  // Function to toggle a role
  const toggleRole = (role) => {
    setSelectedRole(role);
  };

  return (
    <RoleContext.Provider
      value={{
        selectedRole,
        toggleRole
      }}
    >
      {children}
    </RoleContext.Provider>
  );
};

// Helper hook to access context
export const useRole = () => useContext(RoleContext);
